import { useState } from 'react'
import './Sidebar.scss'
import CustomToolTip from '../../../CommonComponents/CustomToolTip';
import { CircularProgress } from '@mui/material';
import { DeleteIcon } from '../Svgs';
import { useSelector } from 'react-redux';
import { MissionStore } from '../../../../store/MissionSlice';
import { LeftbarCloseSvg } from '../../../CommonComponents/svgs/Svgs';

interface SidebarProps {
  delete_sat: any;
  set_delete_sat: (data) => void;
  openModal: (data) => void;
  sidebarLoader: any;
  setSidebarLoader: (data) => void;
  promotedSatellites: any[]
  calculate_orbit_details: (data) => void
}

const Sidebar: React.FC<SidebarProps> = ({ delete_sat, set_delete_sat, openModal, sidebarLoader, setSidebarLoader, promotedSatellites, calculate_orbit_details }) => {

  const [openSlider, setOpenSlider] = useState(true)
  const userData = useSelector((state: { mission: MissionStore }) => state.mission.userData);

  return (
    <div className={`${openSlider && "show_side_bar"} side_bar`}>
      <div className='slider_header'>
        <span>Promote Satellite</span>
        <CustomToolTip title="Add" placement="top">
          <button className='promote_satelite_button' onClick={() => { openModal({ type: 'promote' }) }}>
            <i className='fe fe-plus slider_header__btn__icon fs-18' />
          </button>
        </CustomToolTip>
      </div>
      <div className='slider_caontainer'>
          <LeftbarCloseSvg active={openSlider} onClick={() => setOpenSlider(!openSlider)} />
        {sidebarLoader && <div className='w-100 h-100 d-flex align-items-center justify-content-center'>
          <CircularProgress color='inherit' />
        </div>}
        {!sidebarLoader && promotedSatellites.map((item: any, i) => (

          <div key={i} className={`slider_content`}>
            <div className='slider_content_header'>
              <div className='d-flex align-items-center gap-1 name_section text-truncate' onClick={() => {
                calculate_orbit_details(item)
              }}>
                <span className='header_text w-95 text-truncate'>{item?.['name']}</span>
              </div>
              {userData?.["user_roles"]?.[0] !== "project_viewer" &&
                <div className={`btn_action_section gap-2 ${delete_sat === i ? 'active' : ''}`}>
                  <CustomToolTip title="Delete" placement="top">
                    <button className='sat__delete__button'
                      onClick={(e) => {
                        set_delete_sat(item);
                      }}
                    >
                      <DeleteIcon />
                    </button>
                  </CustomToolTip>
                </div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Sidebar